export default __webpack_public_path__ + "static/media/category-8.a5281d21.svg";